import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Divider, Text } from "theme-ui";
import TableActions from "../../Roles/TableActions";
import { TabelHeadingTxt } from "../../../Text/TabelCommonTxt";
import DataTable from "../../../Tabels/Tabel";
import { getAllocatedHours } from "../../../../store/actions/masterData.action";

const AllocatedHoursMasterData: React.FC = () => {
    const navigate = useNavigate();
    const { paginations } = useSelector((state: any) => state.pagination);
    const { allocatedHours, loader } = useSelector((state: any) => state.masterData);
    const dispatch = useDispatch()
    const [refresh, setRrefresh] = useState<boolean>(true);

    useEffect(() => {
        dispatch(getAllocatedHours())
    }, [dispatch])
    const columns = useMemo<ColumnDef<any>[]>(() => [

        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((paginations?.currentPage - 1) * paginations?.limit) + row?.index + 1}</Text>
                )
            }
        },
        {
            header: "Allocation Hours",
            accessorKey: 'allocatedHours',
            cell: ({ row }) => {

                return (
                    <Text >
                        {row?.original?.
                            allocatedHours
                            || ''}
                    </Text>)
            },
        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-allocatedHours/${row?.original?._id}`} showDelete={false} deleteMessage='' deleteApi={``} toggleRefresh={() => setRrefresh(true)} />
                )
            },
        }
    ], [allocatedHours]);
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Allocated Hours' Count={allocatedHours?.count} IsExportButtonShow={false} onClick={() => { }} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={allocatedHours?.data || []}
                TotalLength={allocatedHours?.count}
                perPageCount={paginations?.limit}
                currentPage={paginations?.currentPage}
                showNavigation={false}
                onPerPageChange={() => { }}
                onPageChange={() => { }}
            />

        </div>
    )
}

export default AllocatedHoursMasterData